module.exports = __webpack_public_path__ + "static/img/iconfont.7ec7e813.svg";